export const BASE_URI = "https://kiswah.yorubacoach.com/api/admin";
